module.exports = components_stencil;